export default function HomePage({ onSignIn, onSignUp }) {
  return (
    <div style={{ background: '#000', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', fontFamily: "'Outfit', sans-serif", overflow: 'hidden' }}>
      <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700;800&display=swap" rel="stylesheet" />
      
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '60%', height: '60%', background: 'radial-gradient(circle, rgba(220,50,50,0.06) 0%, transparent 70%)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <div style={{ position: 'relative', display: 'inline-block', cursor: 'default' }}>
          <img src="/hero.jpg" alt="Folio" style={{ maxHeight: '82vh', width: 'auto', display: 'block' }} />
          
          {/* Clickable can area — larger and centered on the can */}
          <div onClick={() => window.location.href='https://portfolio.cyberballer.com'} style={{
            position: 'absolute', left: '26%', top: '74%', width: '14%', height: '16%',
            cursor: 'pointer', zIndex: 2, borderRadius: 6,
            transition: 'all 0.3s ease',
            border: '1px solid rgba(59,130,246,0.15)',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.boxShadow = '0 0 30px rgba(59,130,246,0.6), 0 0 60px rgba(59,130,246,0.3)';
            e.currentTarget.style.background = 'rgba(59,130,246,0.1)';
            e.currentTarget.style.border = '1px solid rgba(59,130,246,0.4)';
            e.currentTarget.querySelector('.tip').style.opacity = '1';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.boxShadow = 'none';
            e.currentTarget.style.background = 'transparent';
            e.currentTarget.style.border = '1px solid rgba(59,130,246,0.15)';
            e.currentTarget.querySelector('.tip').style.opacity = '0';
          }}>
            <div className="tip" style={{
              position: 'absolute', bottom: -28, left: '50%', transform: 'translateX(-50%)',
              color: '#3B82F6', fontSize: 12, fontWeight: 600, letterSpacing: 1,
              whiteSpace: 'nowrap', textShadow: '0 0 10px rgba(59,130,246,0.5)',
              opacity: 0, transition: 'opacity 0.3s ease',
            }}>Sign In</div>
          </div>
        </div>
      </div>
    </div>
  );
}